module.exports = __webpack_public_path__ + "static/img/2.b419c0c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/static/2.png
// module id = GaVS
// module chunks = 1